(function () {
  'use strict';

  const INITIALIZED_ATTR = 'data-mute-initialized';
  const PLAY_INITIALIZED_ATTR = 'data-play-initialized';
  const ATTACHED_FLAG = 'data-video-mute-attached';

  function isControlled(videoElement) {
    return !!videoElement.querySelector('.video-mute-action');
  }

  function syncVideoToWrapper(videoElement, video) {
    const muted = videoElement.hasAttribute('muted');
    video.muted = muted;
    video.defaultMuted = muted;
    if (muted) {
      video.setAttribute('muted', '');
    } else {
      video.removeAttribute('muted');
    }
  }

  function setGroupMuted(muted) {
    document
      .querySelectorAll('video-element')
      .forEach(function (videoElement) {
        if (!isControlled(videoElement)) return;

        if (muted) {
          videoElement.setAttribute('muted', '');
        } else {
          videoElement.removeAttribute('muted');
        }

        const video = videoElement.querySelector('video');
        if (video) syncVideoToWrapper(videoElement, video);
      });
  }

  function currentGroupMuted() {
    const first = document.querySelector('video-element .video-mute-action');
    if (!first) return true;
    const videoElement = first.closest('video-element');
    return videoElement ? videoElement.hasAttribute('muted') : true;
  }

  function attachVideoListeners(videoElement, video) {
    if (video.dataset.muteListenersAttached) return;
    video.dataset.muteListenersAttached = 'true';

    syncVideoToWrapper(videoElement, video);

    if (!isControlled(videoElement)) return;

    video.addEventListener('play', function () {
      syncVideoToWrapper(videoElement, video);
    });

    video.addEventListener('playing', function () {
      syncVideoToWrapper(videoElement, video);
    });

    video.addEventListener('volumechange', function () {
      const expected = videoElement.hasAttribute('muted');
      if (video.muted !== expected) {
        video.muted = expected;
      }
    });
  }

  function initMuteButton(videoElement) {
    const muteButton = videoElement.querySelector('.video-mute-action');
    if (!muteButton) return;
    if (muteButton.hasAttribute(INITIALIZED_ATTR)) return;

    muteButton.setAttribute(INITIALIZED_ATTR, 'true');

    muteButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setGroupMuted(!currentGroupMuted());
    });
  }

  function initPlayButton(videoElement) {
    const playButton = videoElement.querySelector('.video-play-action');
    if (!playButton) return;
    if (playButton.hasAttribute(PLAY_INITIALIZED_ATTR)) return;

    playButton.setAttribute(PLAY_INITIALIZED_ATTR, 'true');

    playButton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (videoElement.hasAttribute('playing')) {
        videoElement.pause();
      } else {
        videoElement.play();
      }
    });
  }

  function observeVideoElement(videoElement) {
    if (videoElement.hasAttribute(ATTACHED_FLAG)) return;
    videoElement.setAttribute(ATTACHED_FLAG, '');

    const existingVideo = videoElement.querySelector('video');
    if (existingVideo) attachVideoListeners(videoElement, existingVideo);

    const innerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          const videos =
            node.tagName === 'VIDEO'
              ? [node]
              : node.querySelectorAll
                ? Array.from(node.querySelectorAll('video'))
                : [];

          videos.forEach(function (video) {
            attachVideoListeners(videoElement, video);
          });
        });
      });
    });

    innerObserver.observe(videoElement, { childList: true, subtree: true });
  }

  function initVideoElement(videoElement) {
    initMuteButton(videoElement);
    initPlayButton(videoElement);
    observeVideoElement(videoElement);
  }

  function initAll() {
    document.querySelectorAll('video-element').forEach(initVideoElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const rootObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName && node.tagName.toLowerCase() === 'video-element') {
          initVideoElement(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('video-element').forEach(initVideoElement);
        }
      });
    });
  });

  rootObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
